import config from '../config/env';

export default {
        entity: {
                brandList: [],
                classesOfCannabis: [],
                cashFlowError: {},
                productTypesList: [],
                patientList: [],
                vendorList: [],
                employeeDetails: {},
                doctorList: [],
                productListPO: [],
                productList: [],
                employeeList: [],
                purchaseOrderList: [],
                transferList: [],
                productsInTrasitList: [],
                warehouses: [],
                warehouseErrors: [],
                productsWarehouses: [],
                productsTransfer: [],
                productsWarehouseStock: [],
                productsWarehouseSell: [],
                productsWarehouseDamage: [],
                productByCategory: [],
                productCategories: [],
                sellableProducts: [],
                initialSellableProducts: [],
                initialSellableProductsLength: 0,
                posPatients: [],
                posOrder: null,
                posOnSale: false,
                posMemberOnSale: false,
                paymentsList: [],
                deviceRolesList: [],
                deviceTypesList: [],
                deviceWorkStationsList: [],
                cashFlowsList: [],
                taxesrateList: [],
                cashFlowOrders: [],
                openOrdersList: [],
                campaignList: [],
                shiftsList: [],
                shiftsListFilter: [],
                shiftsListFilterLength: 0,
                shiftsListLength: 0,
                orderDetail: [],
                patientOrders: [],
                patientDetail: [],
                productFilter: {
                        productId: null
                },
                mixAndMatchesList: [],
                mixAndMatchesListLength: 0,
                patientRewardPoints: [],
                productOrderList: { list: [], total: 0 },
                productOrderTotal: 0,
                productCampaignList: [],
                productCampaignTotal: 0,
                productPurchaseOrderList: [],
                productPurchaseOrderTotal: 0,
                productGroupList: [],
                onlineOrderList: [],
                bulkUpdateMemberPriceHistoryList: [],
                bulkUpdateMemberPriceCategoryHistoryList: [],
                pin: {
                        authenticated: false,
                        employee: {
                                id: 0,
                                name: ''
                        },
                        error: null
                },
                webBranchId: 3,
                productDetail: {},
                priceMatrix: {},
                checkinList: {
                        list: [],
                        total: 0
                },
                openQueuedOrdersCount: 0,
                openBuddiOrdersCount: 0,
                openLeaflyOrdersCount: 0,
                accessoryVendors: [],
                bulkTransferList: [],
                inventoryAudits: [],
                inventoryAudit: { products: [] },
                inventoryAdjust: [],
                internalMessage: "",
                bannerImageURL: "",
                priceMatricesList: [],
                cashFlowRegisterCount: {},
                messageStatus: false,
                bulkPriceUpdate:{schedular:{}, fileData:[]},
                bulkPriceSchedularList:[],
                bulkPriceSchedularLength:0
        },
        common: {
                webBranchId: 3,
                applicationSettings: {
                        ageValidation: 19,
                        memberDiscountPercentage: 0.03,
                        salesPersonDiscountThreshold: 0,
                        cashInAmountByDefault: 50.00,
                        cashDropAmount: 350.00,
                        suggestedCashDropAmount: 250.00,
                        cashDropAmountToKeep: 50.00,
                        preRollCategoryId: 10,
                        toleranceCashOutAmount: 5.00,
                        doNotShowUnitProductQuantityOver: 5,
                        doNotShowWeightProductQuantityOver: 30,
                        enablePinPasswordOnPOS: false,
                        isMedical: false,
                        isVape: false,
                        isLegal: false,
                        gramAllowance: 30,
                        tokenName: "TECHPOS",
                        memberEnabled: false,
                        showImageInPOSPage: true,
                        branchTransferManuallyReceive: false,
                        fulfillmentEnabled: false,
                        getOpenOnlineOrdersInterval: 0,
                        monerisGiftCardEnabled: false,
                        showRemoveFNTaxBtn: true,
                        showVapeProductSaleDialog: false,
                        StoreManagerCanAccessDashboard: true,
                        autoUpdatePriceWhenReceivingPO: false,
                        showEmployeeNameOnReceipt: true,
                        posReceiptBottomText: '',
                        posShowProductCount: 4,
                        showOpenOnlineOrders: true,
                        showOpenOrders: true,
                        crossProvincesMerchant: false,
                        paystoneGiftCardEnabled: false,
                        posShowCategories: true,
                        padVersion: false,
                        deviceKeyName: '',
                        showOriginalNonMemberPrice: false,
                        noSalesAllowedAfterStoreHours: false,
                        birchmountGiftCardEnabled: false,
                        taxExemptAllEnabled: false,
                        showPOSBulkImport: false,
                        isHighTide: false,
                        isInspired: false
                },
                userBranches: undefined,
                branchId: null,
                unauthorizedUser: false,
                isUserAuthenticated: null,
                isChangePasswordModalOpen: false,
                loginSuccess: false,
                loginError: null,
                store: {
                        apiUrl: config.baseUrl(),
                        posAPIUrl: config.posAPIUrl(),
                        name: "",
                        phone: "",
                        site: "",
                        street: "",
                        city: "",
                        provinceState: "BC",
                        country: "CA",
                        postalCode: "",
                        GSTNumber: "",
                        hideRewardsReceipt: false,
                        hideMedicalLabelReceipt: false,
                        memberLabelReceipt: "Patient",
                        monerisEnabled: false,
                        monerisStoreId: "",
                        monerisPostUrl: "",
                        shippingCostEnabled: "",
                        version: ""
                },
                checkInDialog: false,
                auditUpdating: 0
        },
        reports: {
                annualSales: [],
                budtenderAvgSales: [],
                transactionSummary: [],
                transactionSalesSummary: {},
                profitReport: {},
                productPriceChangeReport: [],
                productSales: {},
                dailyCashSummary: [],
                salesSummary: [],
                taxSummary: {},
                inventoryLevel: [],
                shiftByEmployee: [],
                shiftByDay: [],
                salesByType: {},
                productVelocity: {},
                customerSales: [],
                inventorySnapShot: [],
                revenueReport: [],
                manualInventoryChange: [],
                inventoryMovement: [],
                inventoryLog: [],
                destroyedProductReport: [],
                discrepancyReport: [],
                hourlySales: [],
                sellThrough: [],
                dailySalesReport: {},
                monthlySalesReport: {},
                yearlySalesReport: {},
                dailyProfitReport: {},
                monthlyProfitReport: {},
                yearlyProfitReport: {},
                purchaseorderReport: {},
                endOfDay: {},
                generalReport: {},
                discountReport: {},
                categorySales: {},
                reorder: [],
                gmroi: [],
                warehouseTransfer: [],
                combinedSales: {},
                creditPayments: {},
                shoppingTrend: {},
                budgetPlanner: {},
                aggregateBranches: {},
                aggregateSales: [],
                aggregateInventory: [],
                vendorSales: [],
                tHCCBDTracker: [],
                priceTracker: [],
                baseStore: [],
                compareTo: [],
                salesSummaryDetails: {},
                aggregateBranchSalesInventory: {},
                demographicReportGender: [],
                demographicReportAge: []
        },
        dashboard: {
                orders: {},
                sales: {
                        totalAmount: 0
                },
                topSellers: [],
                campaings: [],
                cashDrawer: [],
                topProducts: [],
                members: [],
                purchaseOrders: {
                        numberOfOpenPurchaseOrders: 0,
                        weeklyData: {
                                numberOfPurchaseOrders: 0,
                                amountOfPurchaseOrders: 0
                        },
                        monthlyData: {
                                numberOfPurchaseOrders: 0,
                                amountOfPurchaseOrders: 0
                        },
                        purchaseOrders: []
                },
                inventory: [],
                timesheet: []
        }
};
